import { type ErrorObject } from "serialize-error";
import { type SerializedError } from "@reduxjs/toolkit";
import { authErrorCodes } from "../../supabase/supabaseAuthErrorCodes";

function processRtkError(error: ErrorObject | SerializedError) {
  switch (error.code) {
    case authErrorCodes.IDENTITY_ALREADY_EXISTS: {
      return {
        title: "Unable to create account",
        description: "Please try a different set of credentials",
      };
    }
    case authErrorCodes.INVALID_CREDENTIALS: {
      return {
        title: "Incorrect email or password",
        description: "Try entering your credentials again",
      };
    }
    default: {
      return {
        title: "Something went wrong",
        description: "Please try again later",
      };
    }
  }
}

export { processRtkError };
